import React, { useContext } from 'react';
import { styled } from 'linaria/react';
import SiteContentContext from '../../SiteContent/SiteContentContext';
import { theme } from '../../Theming/Theming';
import { ContentLink } from '../../ContentRender/ContentLink';
import { contentTextElements } from '../../ContentRender/ContentText';

const animationLength = 800;

const Wrapper = styled('div')`
  width: 100%;
  position: relative;
  padding: 12px 2rem;
  text-align: center;
  background-color: ${theme.colors.secondary};
  max-width: 100%;
  opacity: 0;
  animation-name: enter;
  animation-duration: ${animationLength}ms;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  z-index: 50;
  background: ${props => props.background};
  &,
  > a {
    width: 100%;
  }
  &.unmounting {
    animation-name: exit;
  }
  button {
    position: absolute;
    right: 10px;
    top: 50%;
    padding: 5px;
    margin: -5px;
    margin-top: -12px;
    svg {
    }
  }
  ${contentTextElements}, svg {
    display: inline-block;
    color: ${props => props.color};
    &:not(:first-child) {
      margin-left: 5px;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    text-transform: uppercase;
  }

  p {
    margin: 0;
  }

  @keyframes enter {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes exit {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

const CampaignBar = () => {
  const {
    campaignBar: campaignBarHtml,
    showCampaignBar,
    campaignBarLink,
    campaignBarBackground,
    campaignBarColor
  } = useContext(SiteContentContext);

  return showCampaignBar ? (
    <Wrapper
      className={`campaign-bar-wrapper`}
      background={campaignBarBackground}
      color={campaignBarColor}
    >
      {campaignBarLink ? (
        <ContentLink to={campaignBarLink}>{campaignBarHtml}</ContentLink>
      ) : (
        <>{campaignBarHtml}</>
      )}
    </Wrapper>
  ) : null;
};

export default CampaignBar;
